import { Property } from '@propertypal/shared/src/types/property';
import React, { FunctionComponent } from 'react';
import { Container, Content } from './PropertyAttributes.style';

interface Props {
  property: Property;
}

const PropertyAttributes: FunctionComponent<Props> = (props) => {
  if (!props.property.attributes?.length) {
    return null;
  }
  const title = `On-site perks of living at ${props.property.name || props.property.development?.name}`;

  return (
    <Container title={title}>
      <Content>
        {props.property.attributes.map((attribute) => (
          <p key={attribute.id}>{attribute.text}</p>
        ))}
      </Content>
    </Container>
  );
};

export default PropertyAttributes;
